// events/authenticationEvent.ts

import { AuthenticationType } from '../utils/authenticationType';

export const AUTHENTICATION_FAILED_EVENT = 'vw:authenticationFailed';

/**
 * Announces that the server rejected a login or registration attempt. Currently this
 * is only ever fired during the checkout flow as other authentication flows reload
 * the page entirely.
 *
 * @param {AuthenticationType} type - The type of authentication that failed
 */
export function dispatchAuthenticationFailed(type: AuthenticationType): void {
	document.dispatchEvent(
		new CustomEvent<AuthenticationType>(AUTHENTICATION_FAILED_EVENT, { detail: type }),
	);
}

/**
 * Listens for a rejected attempt on one specific form, ignoring the other form's failures.
 *
 * @param {AuthenticationType} type - The type of failure to listen for
 * @param {() => void} handler - Called when an authentication failure of that type occurs
 */
export function onAuthenticationFailed(type: AuthenticationType, handler: () => void): void {
	document.addEventListener(AUTHENTICATION_FAILED_EVENT, (event) => {
		if (event.detail === type) {
			handler();
		}
	});
}
